import {ref} from 'vue';

export default function useInstructions(){        
    const allInstructions = ref([]);
    const taskInputData = ref("");
    
    function addInstruction(){
        allInstructions.value.push({
            instructionData: taskInputData.value,
            required: false,
            subtasks: [],
        });
        taskInputData.value = "";
    }
    function removeTask(item){
        allInstructions.value.splice(allInstructions.value.indexOf(item), 1);
            //console.log(allInstructions.value);
    }
    function addSubtask(instruction, subtaskText){
        if (!instruction.subtasks) {
            instruction.subtasks = [];
        }
        instruction.subtasks.push(subtaskText);
    }
    function removeSubtask(instruction, subtask){
        if (!instruction.subtasks) return;
        instruction.subtasks.splice(instruction.subtasks.indexOf(subtask), 1);
    }
    function submitInstruction(){
        allInstructions.value.forEach((instruction, index) => {
            instruction.instructionNumber = index + 1;
        });
    }
    return{
        allInstructions,
        taskInputData,
        addInstruction,
        removeTask,
        addSubtask,
        removeSubtask,
        submitInstruction,
    }
}


// WEBPACK FOOTER //
// ./src/components/game-dashboard/dashboardComposables/useInstructions.js